<template>
  <WsMain pb240px class="allow-overflow">
    <WsTitle>批次建立多語系</WsTitle>
    <v-stepper v-model="step" class="elevation-0 transparent">
      <v-stepper-header class="elevation-0">
        <v-stepper-step step="1" editable>設定</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" editable>匯入來源</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" editable>編輯內容</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="mt-5">
        <v-stepper-content step="1" class="pa-0">
          <WsCallout
            :icon="callout.icon"
            :title="callout.title"
            :remark="callout.remark"
            :btns="callout.btns"
            :backgroundColor="callout.backgroundColor"
            class="mb-5"
          />
          <ValidationObserver ref="ValidationObserverStep1">
            <WsCard>
              <WsContent>
                <v-row>
                  <v-col
                    v-for="(parseField, parseFieldKey) in parseFields"
                    :key="parseFieldKey"
                    sm="12"
                    cols="12"
                  >
                    <WsState
                      v-model="parseFieldValues[parseField.valueKey]"
                      :type="parseField.type"
                      :label="parseField.label"
                      :items="parseField.items"
                      :defaultValue="parseField.defaultValue"
                      :clearable="parseField.clearable"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-for="(localeField, localeFieldKey) in localeFields"
                    :key="localeFieldKey"
                    sm="3"
                    cols="12"
                  >
                    <WsState
                      v-model="localeFieldValues[localeField.valueKey]"
                      required
                      type="select"
                      rules="required"
                      :items="_localeItems"
                      :label="localeField.label"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-for="(otherField, otherFieldKey) in otherFields"
                    :key="otherFieldKey"
                    cols="12"
                    sm="12"
                  >
                    <WsState
                      v-model="otherFieldValues[otherField.valueKey]"
                      :type="otherField.type"
                      :label="otherField.label"
                      :maxlength="otherField.maxlength"
                    />
                  </v-col>
                </v-row>
              </WsContent>
            </WsCard>
          </ValidationObserver>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <WsCard>
            <WsContent>
              <WsContentTitle>法條</WsContentTitle>
              <ValidationObserver ref="ValidationObserverStep2">
                <WsState v-model="rawArticle" required type="textarea" rules="required" />
              </ValidationObserver>
            </WsContent>
          </WsCard>
        </v-stepper-content>
        <v-stepper-content step="3" class="pa-0">
          <v-row v-if="isLoading.articleVersionList">
            <v-col>
              <v-skeleton-loader type="image" class="mb-5" />
              <v-skeleton-loader type="image" class="mb-5" />
              <v-skeleton-loader type="image" class="mb-5" />
            </v-col>
            <v-col>
              <v-skeleton-loader type="image" class="mb-5" />
              <v-skeleton-loader type="image" class="mb-5" />
              <v-skeleton-loader type="image" class="mb-5" />
            </v-col>
          </v-row>
          <LvCompareInfoAndState
            v-else-if="step === 3"
            leftTitle="基準語言"
            rightTitle="增譯語言"
            :displayFields="displayFields"
            :newList="parseArticleList"
            :oldList="articleVersionList"
            :oldLocale="localeFieldValues.baselineLocale || ''"
            :newLocale="localeFieldValues.translateLocale || ''"
            @input="$_onCompareInfoAndStateInput($event)"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <WsMainBottomNav>
      <WsBtn v-if="step !== 1" outlined color="textSecondary" @click="$_onClickPre">上一步</WsBtn>
      <WsBtn v-if="step !== 3" :loading="isLoading.submit" @click="$_onClickNext">下一步</WsBtn>
      <WsBtn v-if="step === 3" :loading="isLoading.submit" @click="$_onSubmit">送出</WsBtn>
    </WsMainBottomNav>
    <WsAlertDialog
      ref="WsAlertDialog"
      :title="alertPopup.title"
      :color="alertPopup.color"
      :btnText="alertPopup.btnText"
      :hideCancelBtn="alertPopup.type === 'noParseArticle'"
      @submit="$_onClickAlertDialog($event)"
    />
  </WsMain>
</template>

<script>
import M_article from '@/models/article';
import S_articleVersion from '@/services/api/v1/articleVersion';

export default {
  data() {
    return {
      step: 1,
      isLoading: {
        submit: false,
        articleVersionList: false,
      },
      parseFields: M_article.parseFields,
      parseFieldValues: {},
      localeFields: M_article.localeFields,
      localeFieldValues: {},
      otherFields: M_article.otherFields,
      otherFieldValues: {},
      rawArticle: '',
      parseArticleList: [],
      articleVersionList: [],
      compareFields: M_article.fields.last_version.fields.locales.fields,
      articleDisplayFieldKeys: [
        'book',
        'part',
        'chapter',
        'division',
        'section',
        'sub_section',
        'no_text',
        'content',
      ],
      callout: {
        icon: {
          type: 'mdi-information-outline',
          color: '#116795',
        },
        title: {
          text: '請選擇已具備翻譯內容的語言作為基準語言',
          color: '#116795',
        },
        backgroundColor: '#ddeef7',
      },
      alertPopup: {
        type: '',
        title: '編輯的內容會清除，確認要返回上一步嗎？',
        btnText: '確認',
      },
      displayFields: [],
    };
  },
  computed: {
    _actVersionId() {
      return this.$route.params.version_id;
    },
    _localeItems() {
      const locales = this.$store.state.locale.locales;
      if (!locales) return [];
      return locales.map(({ code, name }) => ({
        value: code,
        text: name,
      }));
    },
  },
  async mounted() {
    await this.$_init();
  },
  methods: {
    async $_init() {
      this.parseFieldValues = this.$_initFieldValues(this.parseFields);
      this.isLoading.articleVersionList = true;
      await this.$_getArticleVersionList();
      this.isLoading.articleVersionList = false;
    },
    $_initFieldValues(fields) {
      return fields.reduce((acc, field) => {
        acc[field.valueKey] = field.defaultValue || null;
        return acc;
      }, {});
    },
    async $_getArticleVersionList() {
      const paramsBase = {
        act_versions: this._actVersionId,
        order_by: 'no_number',
        order_way: 'asc',
      };
      let page = 1;
      let hasMore = true;
      try {
        while (hasMore) {
          const { data, meta } = await S_articleVersion.index({
            params: { ...paramsBase, page },
            pagination: true,
          });
          this.articleVersionList.push(...data);
          if (page >= meta.last_page) {
            hasMore = false;
          } else {
            page++;
          }
        }
      } catch (err) {
        console.error('$_getArticleVersionList failed', err);
      }
    },
    $_onSetAlertPopup(type) {
      const alertList = {
        noParseArticle: {
          type,
          title: '法條解析失敗，請檢查法條內容或解析設定',
          btnText: '確認',
          color: 'primary',
        },
        resetWarning: {
          type,
          title: '編輯的內容會清除，確認要返回上一步嗎？',
          btnText: '確認',
        },
      };
      return (
        alertList[type] || {
          title: '發生錯誤',
          btnText: '確認',
        }
      );
    },
    $_onClickPre() {
      if (this.step === 3) {
        this.alertPopup = this.$_onSetAlertPopup('resetWarning');
        this.$refs.WsAlertDialog.open();
      } else {
        this.step--;
      }
    },
    async $_onClickNext() {
      if (this.step === 1) {
        const isValidateStep1 = await this.$refs.ValidationObserverStep1.validate();
        if (!isValidateStep1) return;
        this.step++;
      } else if (this.step === 2) {
        const isValidateStep2 = await this.$refs.ValidationObserverStep2.validate();
        if (!isValidateStep2) return;
        const parseSettings = this.$_getParseSettings();
        this.displayFields = this.$_setDisplayFields(parseSettings);
        this.parseArticleList = this.$_getParseArr(this.rawArticle, parseSettings);
        if (this.parseArticleList.length === 0) {
          this.alertPopup = this.$_onSetAlertPopup('noParseArticle');
          this.$refs.WsAlertDialog.open();
        } else {
          this.step++;
        }
      }
    },
    $_getParseSettings() {
      return Object.entries(this.parseFieldValues).reduce((acc, [key, value]) => {
        if (key === 'articleInlineTextRule' || value == null) return acc;
        acc.push({ key, regex: new RegExp(value) });
        return acc;
      }, []);
    },
    $_setDisplayFields(parseSettings) {
      const allFields = M_article.fields.last_version.fields.locales.fields;
      const displayFields = (parseSettings || []).reduce((acc, { key }) => {
        const field = allFields[key];
        if (field) acc[key] = field;
        return acc;
      }, {});
      const contentField = allFields.content;
      displayFields.content = contentField;
      return displayFields;
    },
    $_getParseArr(text, parseSettings) {
      if (!text || !parseSettings || parseSettings.length === 0) return [];
      const parseArr = [];
      const lineArr = text.match(/[^\r\n]+/g);
      if (!lineArr) return [];

      const baseParseItem = { content: '', isSelected: false };
      parseSettings.forEach(({ key }) => {
        baseParseItem[key] = '';
      });
      const inlineTextAsContent = this.parseFieldValues.articleInlineTextRule === 'asContent';

      lineArr.forEach((lineItem) => {
        const line = lineItem.trim();
        if (!line) return;

        const lastParse = parseArr[parseArr.length - 1];
        let matched = false;

        // 尋找匹配的解析設定
        for (let i = 0; i < parseSettings.length; i++) {
          const { key, regex } = parseSettings[i];
          const matchArr = line.match(regex);
          if (matchArr && matchArr[0].length === line.length) {
            const isArticleInlineAsContent = key === 'no_text' && inlineTextAsContent;
            const keyContent = isArticleInlineAsContent
              ? matchArr[1].trim()
              : `${matchArr[1].trim()} ${matchArr[2].trim()}`;
            const content = isArticleInlineAsContent ? matchArr[2].trim() : '';
            const parseItem = {
              ...baseParseItem,
              [key]: keyContent,
              ...(content ? { content } : {}),
            };

            if (i === 0) {
              // 第一個設定匹配，建立新項目
              parseArr.push(parseItem);
            } else {
              // 後續設定匹配
              if (!lastParse) {
                // 沒有最後一個項目，建立新項目
                parseArr.push(parseItem);
              } else if (
                lastParse &&
                (lastParse[key] || lastParse[parseSettings[parseSettings.length - 1].key])
              ) {
                // 如果最後一個項目已有此欄位或是最後一個項目有最後一個parseSettings的設定(目前是內容欄位)，則建立新項目
                parseArr.push(parseItem);
              } else if (lastParse) {
                // 否則更新最後一個項目
                lastParse[key] = keyContent;
                if (isArticleInlineAsContent) {
                  lastParse.content = lastParse.content
                    ? `${lastParse.content}\n${content}`
                    : content;
                }
              }
            }

            matched = true;
            break;
          }
        }

        // 如果沒有匹配任何設定且有最後一個項目，將內容加入
        if (!matched && lastParse) {
          lastParse.content = lastParse.content ? `${lastParse.content}\n${line}` : line;
        }
      });

      return parseArr;
    },
    async $_onSubmit() {
      this.isLoading.submit = true;
      try {
        const translateLocaleCode = this.localeFieldValues.translateLocale;
        const needTranslateArticleVersionList = this.articleVersionList
          .filter((version) => version.locales && !version.locales[translateLocaleCode])
          .slice(0, this.parseArticleList.length);
        for (let i = 0; i < needTranslateArticleVersionList.length; i++) {
          const versionId = needTranslateArticleVersionList[i].id;
          const translateLocale = this.parseArticleList[i];
          await S_articleVersion.update(versionId, {
            locales: { [translateLocaleCode]: translateLocale },
            reference_link: this.otherFieldValues?.reference_link ?? '',
          });
        }
        this.$_navigateAfterBatch();
      } catch (err) {
        console.error('$_onSubmit failed', err);
        alert(
          '批次建立多語言錯誤，但可能已經建立部分法條的多語言，請回到法規內頁，確認目前有哪些法條的多語言尚未上傳，再繼續進行批次建立多語言',
        );
        this.$_navigateAfterBatch();
      } finally {
        this.isLoading.submit = false;
      }
    },
    $_navigateAfterBatch() {
      const redirectUrl = this.$route?.query?.redirect
        ? this.$route.query.redirect
        : `act/${this.$route.params.id}`;
      this.$router.push(redirectUrl);
    },
    $_onCompareInfoAndStateInput(event) {
      const { newItemIndex, fieldKey, value } = event;
      this.parseArticleList[newItemIndex][fieldKey] = value;
    },
    $_onClickAlertDialog() {
      this.$refs.WsAlertDialog.close();
      if (this.alertPopup.type === 'resetWarning') this.step--;
    },
  },
};
</script>

<style lang="scss" scoped>
.allow-overflow ::v-deep {
  margin-bottom: 100px;
  .v-stepper,
  .v-stepper__items,
  .v-stepper__content,
  .v-stepper__wrapper {
    overflow: visible !important;
  }
}
</style>
